module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "normal5"
  }, [_c('span', {
    staticClass: "charoverride7"
  }, [_c('br', {
    staticClass: "calibre7"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal5"
  }, [_c('span', {
    staticClass: "charoverride7"
  }, [_vm._v("No man is lonely while eating spaghetti. ")])]), _vm._v(" "), _c('p', {
    staticClass: "normal6"
  }, [_c('span', {
    staticClass: "charoverride8"
  }, [_vm._v("—Robert Morley")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e27c2a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Epigraph.vue
// module id = 75
// module chunks = 0